import React from "react";
import { connect } from "react-redux";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import Users from "./Users";
import Roles from "./Roles";

const UserSecurityV2 = (props) => {
    return (
        <div className="h-100" style={{ overflowY: 'hidden'}}>
            <TabPanel className="review-tabs h-100">
                <Item className="h-100" title="Users" style={{ textTransform: "math-auto" }}>
                    <Users></Users>
                </Item>
                <Item title="Roles" style={{ textTransform: "math-auto" }}>
                    <Roles></Roles>
                </Item>
            </TabPanel>
        </div>
    )
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UserSecurityV2);